import * as React from 'react';
import Svg, {
  SvgProps,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => {
  const uniqueId = React.useId(); // React 18+

  const gradientId = `gradA-${uniqueId}`;
  return (
    <Svg
      width={74}
      height={73}
      viewBox={'0 0 74 73'}
      {...props}
      fill="none"
      stroke="none">
      <Defs>
        <LinearGradient
          id={gradientId}
          x1={21.82}
          x2={52.37}
          y1={3.609}
          y2={69.129}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="#7CF3FF" />
          <Stop offset={0.07} stopColor="#71EBFA" />
          <Stop offset={0.2} stopColor="#56D6EF" />
          <Stop offset={0.35} stopColor="#2AB5DD" />
          <Stop offset={0.38} stopColor="#23B0DB" />
          <Stop offset={0.46} stopColor="#23A4DD" />
          <Stop offset={0.61} stopColor="#2487E2" />
          <Stop offset={0.81} stopColor="#2657EB" />
          <Stop offset={1} stopColor="#2823F5" />
        </LinearGradient>
      </Defs>
      <Path
        fill="#0B0D6F"
        d="M36.78 68.74c17.878 0 32.37-14.492 32.37-32.37C69.15 18.493 54.658 4 36.78 4 18.903 4 4.41 18.493 4.41 36.37c0 17.878 14.493 32.37 32.37 32.37Z"
      />
      <Path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M49.49 34.25c0 7.02-5.69 12.72-12.72 12.72s-12.72-5.69-12.72-12.72"
      />
      <Path
        stroke="#fff"
        strokeWidth={1.5}
        d="M30.42 23.649c0-3.51 2.85-6.36 6.36-6.36 3.51 0 6.36 2.85 6.36 6.36v10.6c0 3.51-2.85 6.36-6.36 6.36-3.51 0-6.36-2.85-6.36-6.36v-10.6Z"
      />
      <Path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M36.78 46.96v8.48M32.54 55.438h8.48M38.89 23.648h4.24M38.89 30.008h4.24"
      />
      <Path
        stroke={`url(#${gradientId})`}
        strokeMiterlimit={10}
        strokeWidth={4}
        d="M37.1 70.519c-18.83 0-34.15-15.32-34.15-34.15S18.27 2.219 37.1 2.219s34.15 15.32 34.15 34.15-15.32 34.15-34.15 34.15Z"
      />
    </Svg>
  );
};
export default SvgComponent;
